module.exports = __webpack_public_path__ + "static/media/Bruxish_gaussian2.ce100a8e.png";